export default {
    appointmentVisitor: {
        path: '/appointmentVisitor',
        name: 'appointmentVisitor',
        meta: {
            title: '预约来访'
        },
        component: () => import('./index.vue')
    }
};
